import $ from "jquery";

$(document).ready(function () {
    if ($('.video-modal').length) {
        if (window.ytPlayers === undefined) {
            let tag = document.createElement('script');
            tag.src = 'https://www.youtube.com/iframe_api';
            let firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

            window.ytPlayers = {};
        }

        $('.video-modal').each(function () {
            var videoID = $(this).attr('id').replace('video-modal-', '');
            window.ytPlayers['video-modal-placeholder-' + videoID] = {
                width: '595',
                height: '360',
                videoId: videoID,
                playerVars: {
                    rel: '0'
                }
            };
        });

        $('.video-callout').on('click', function () {
            let iframeID = $('[data-open]', this).data('open').replace('video-modal', 'video-modal-placeholder');
            window.ytPlayers[iframeID].player.playVideo();
        });
        $(document).on('click', '.reveal-overlay', function () {
            if ($('.video-modal', this).length) {
                let iframeID = $('iframe', this).attr('id');
                window.ytPlayers[iframeID].player.stopVideo();
            }
        });
    }
});

window.onYouTubeIframeAPIReady = function () {
    // create a player for each placeholder
    let keys = Object.keys(window.ytPlayers);
    for (let i = 0; i < keys.length; i++) {
        let key = keys[i];
        window.ytPlayers[key].player = new YT.Player(key, window.ytPlayers[key]);
    }
}